module.exports = __webpack_public_path__ + "static/media/bg.e1a7ec08.jpg";